import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function subdomaincheck(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/subdomaincheck`, body, config);
  return data;
}

export async function addLayanan(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/newrequest`, body, config);
  return data;
}

export async function startNewQuestionnaire(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.put(`${apiUrl}/mylayanan/newkategorise`, body, config);
  return data;
}

export async function getlayanans(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/getlayanans`, body, config);
  return data;
}

export async function getLayananByID(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/mylayanan/${id}`, config);
  return data;
}

export async function getLayananByIDPublicReqe(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/publicreq/layanan/${id}`, config);
  return data;
}

export async function getRekomendasis(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/getrekomendasis`, body, config);
  return data;
}

export async function getLayananActivities(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/getactivity`, body, config);
  return data;
}

export async function getLayananAggregate(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/mylayanan/getaggregate`, body, config);
  return data;
}

export async function deleteLayanan(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  config.data = body;
  const { data } = await http.delete(`${apiUrl}/mylayanan`, config);
  return data;
}
